export const gameDetailsController = {
  initial: 'idle',
  states: {
    idle: {
      on: {
        LAYOUT_CHANGE_END: {
          target: 'showGameDetails',
          cond: 'isGameDetailsPage',
          actions: ['setBodyNonScrollable'],
        },
      },
    },
    showGameDetails: {
      on: {
        ROUTE_CHANGED: {
          target: 'idle',
          actions: [
            {
              type: 'setLayoutProperty',
              data: {
                path: 'components.GameDetailsModal.properties.componentVisible',
                value: false,
              },
            },
          ],
        },
      },
    },
  },
};
